import React, { useState, useEffect } from 'react';
import close from '../../assets/design/pricing/closing-x.png';
import calendar from '../../assets/design/dashboard/calendar.png';
import './DashboardPopups.css';
import { Link, useNavigate } from 'react-router-dom';
import { isAuthed } from '../../services/auth.service';
import { getAvailableSellersAll, addUserEventTracking, addCompanyClick, createSellerDemo, getUserProfile, hasAvailableApplications, getAvailableOffers, companyOfferUse, getCompanyCampaigns } from '../../utils/api';
import { Gift, Video, Star } from 'lucide-react';
import QualifierQuestions from '../../components/qualifier/QualifierQuestions';
import AvailableTimes from '../../components/qualifier/AvailableTimes';
import SubmitTimes from '../../components/qualifier/SubmitTimes';
import FadeIn from '../../utils/fadein';
import Share from '../search/Share';
import { FaCheckCircle, FaTimes, FaCheck } from 'react-icons/fa';
import { BadgeDollarSign, Link2, PenIcon, Ticket, InfoIcon } from 'lucide-react';
import { Spinner } from '@chakra-ui/react';
import useSubscriberStatus from '../../hooks/useSubscriberStatus';

const BoostAnalytics = () => {
  const navigate = useNavigate();
  const [results, setResults] = useState([]);
  const [bookingLoading, setBookingLoading] = useState(false);
  const [currentDemo, setCurrentDemo] = useState(null);
  const [currentDemoId, setCurrentDemoId] = useState(null);
  const [showQualifier, setShowQualifier] = useState(false);
  const [showAdvice, setShowAdvice] = useState(false);
  const [showMaxReached, setShowMaxReached] = useState(false);
  const [selectedCompanyId, setSelectedCompanyId] = useState(null);
  const [adviceType, setAdviceType] = useState(null);
  const [hasAvailable, setHasAvailable] = useState(false);
  const [showHasNoCompany, setShowHasNoCompany] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [hasCompany, setHasCompany] = useState(false);
  const [currentCompanyId, setCurrentCompanyId] = useState(null);
  const [showHasApplied, setShowHasApplied] = useState(false);
  const [showUnverified, setShowUnverified] = useState(false);
  const [isVerified, setIsVerified] = useState(false);

  const [loading, setLoading] = useState(false);
  const [expandedDescriptions, setExpandedDescriptions] = useState({});
  const {subscriberLoading, subscriberData} = useSubscriberStatus();
  const [campaigns, setCampaigns] = useState([]);
  const [loadedCampaigns, setLoadedCampaigns] = useState(false);

  const imageUrl = process.env.REACT_APP_IMAGE_URL;

   async function fetchData() {
      setLoading(true); // Set loading to true before fetch
      const response = await getCompanyCampaigns();
      if (response.success) {
        setResults(response.data);
      }
      setLoading(false);
    }

  useEffect(() => {
    if (isAuthed()) {
      setIsLoggedIn(true);
    }
  }, []);

  useEffect(() => {
    async function fetchData() {
      setLoading(true); // Set loading to true before fetch
      const response = await getCompanyCampaigns();

      console.log('response', response);
      if (response.success) {
        setResults(response.data);
      }
      setLoading(false);
    }

    async function loadUserProfile() {
      let res = await getUserProfile();

      console.log(res.data);

      if (res.success) {
        let _user = res.data;

        if (_user.work_email_verified) {
          setIsVerified(true);
        }

        else {
          setIsVerified(false);
        }

        if (_user.company_id != null) {
          setHasCompany(true);
        }
      }
    }
    loadUserProfile();
    fetchData();
  }, []);

  function demoAccepted() {
    let _filter = results.filter(item => item.company_id !== selectedCompanyId);
    setResults(_filter);
  }

  async function handleQualifierClick(demo_id, item) {
    console.log(demo_id, item);
    setSelectedCompanyId(item.company_id);
    if (isLoggedIn === false) {
      setAdviceType('RequestDemo');
      setShowAdvice(true);
      setBookingLoading(false);
      return;
    }

    if (hasCompany === false) {
      console.log("no company info found");
      setShowHasNoCompany(true);
      return;
    }

    setBookingLoading(true);
    setSelectedCompanyId(item.company_id);
    setCurrentCompanyId(item.company_id);

    let _check = await hasAvailableApplications();

    if (_check.success) {
      if (_check.data === true) {
        setShowMaxReached(false);
        setHasAvailable(true);
      }

      else {
        setHasAvailable(false);
        setShowMaxReached(true);
        setBookingLoading(false);
        return;
      }
    }

    if (demo_id === null) {
      let data = { seller_id: item.seller_id };
      let _res = await createSellerDemo(data);

      if (_res.success) {
        setCurrentDemo(item);
        setCurrentDemoId(_res.data);
        setShowQualifier(true);
      }

      else {
        if (_res.has_applied != null && _res.has_applied === true) {
          setShowHasApplied(true);
          // alert("Looks like you have already applied to this company in the past. We only allow 1 application per company per user currently.")
        }

        else {
          setCurrentDemo(item);
          setCurrentDemoId(_res.demo_id);
          setShowQualifier(true);
        }
      }

      setBookingLoading(false);
    }

    else {
      setCurrentDemo(item);
      setCurrentDemoId(demo_id);
      setShowQualifier(true);
      setBookingLoading(false);
    }

    await addUserEventTracking('Book demo click', demo_id);
    await addCompanyClick(item.company_id, 'Discover software');
  }


  return (
    <>
       <div className="min-h-screen bg-gray-50 dark:bg-dark">
      <div className="container-custom py-6 px-4 mx-auto">

        <div className="flex justify-between items-center mb-8">
          <div>
            <div className="flex items-center gap-4 mb-2">
              <h1 className="text-3xl font-bold text-gray-900">Boosts Dashboard</h1>
              {!subscriberLoading && subscriberData != null && subscriberData.length > 0 && (
                <div className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-gradient-to-r from-purple-500 to-pink-500 text-white">
                  {subscriberData[0].name}
                </div>
              )}

              {!subscriberLoading && (subscriberData == null || subscriberData.length == 0) && (
                <div className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-gradient-to-r from-purple-500 to-pink-500 text-white">
                  Free Plan
                </div>
              )}

            </div>
            <p className="text-gray-600 mt-2">Track and analyze your lead generation performance</p>
          </div>
        </div>

        {/* Stats Cards */}
        <div className="mb-6">
          <div className="bg-white rounded-lg shadow-sm p-6">
            <div className="grid grid-cols-3 gap-6">
              <div>
                <p className="text-sm font-medium text-gray-500">Total Subscribers</p>
                <p className="mt-2 text-3xl font-semibold text-gray-900">
                  {results.reduce((sum, item) => sum + (item.subscriber_count || 0), 0).toLocaleString()}
                </p>
              </div>
              <div>
                <p className="text-sm font-medium text-gray-500">Total Impressions</p>
                <p className="mt-2 text-3xl font-semibold text-gray-900">
                  {results.reduce((sum, item) => sum + (item.impressions || 0), 0).toLocaleString()}
                </p>
              </div>
              <div>
                <p className="text-sm font-medium text-gray-500">Total Clicks</p>
                <p className="mt-2 text-3xl font-semibold text-gray-900">
                  {results.reduce((sum, item) => sum + (item.clicks || 0), 0).toLocaleString()}
                </p>
              </div>
            </div>
          </div>
        </div>

        {loading ? (
          <div className="flex items-center justify-center py-12">
            <Spinner />
          </div>
        ) : (
          <div className="bg-white rounded-lg shadow-sm">
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead>
                  <tr className="border-b border-gray-200">
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Date</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Source</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Campaign Name</th>
                    <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">Subscribers</th>
                    <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">Impressions</th>
                    <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">Clicks</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {results.map((item, index) => (
                    <tr key={index} className="hover:bg-gray-50">
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {new Date(item.date_scheduled).toLocaleDateString('en-US', {
                          month: 'short',
                          day: 'numeric',
                          year: 'numeric'
                        })}
                      </td>

                      <td>
                        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                          item.source_name === 'Beehiiv'
                            ? 'bg-blue-50 text-blue-700'
                            : 'bg-purple-50 text-purple-700'
                        }`}>
                          {item.source_name}
                        </span>
                      </td>

                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{item.source_description}</td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 text-right">{item.subscriber_count.toLocaleString()}</td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 text-right">{item.impressions.toLocaleString()}</td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 text-right">{item.clicks.toLocaleString()}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

      </div>
    </div>
    </>
  );
};

export default BoostAnalytics;
